<template>
  <div class="header row align-center">
    <div class="menu-mobile show-s grid-2-s" @click="showMenu = !showMenu">
      <button :class="showMenu ? 'close' : ''"></button>
      <ul class="menu column" :class="showMenu ? 'opened' : ''">
        <template v-if="user.perfil == 'agregado_cliente'">
          <li :class="menu.remote ? 'active' : ''" @click="changeMenu('remote')">
            <router-link to="/cliente/historico">HISTÓRICO</router-link>
          </li>
        </template>
        <template v-else>
          <li>
            <router-link to="/cliente/dashboard">DASHBOARD</router-link>
          </li>
          <li>
            <router-link to="/cliente/acompanhamento">ACOMPANHAMENTO</router-link>
          </li>
          <li v-if="user.nova_solicitacao">
            <router-link to="/cliente/job/novo">NOVA SOLICITAÇÃO</router-link>
          </li>
          <li v-if="user.url_relatorio">
            <router-link to="/cliente/relatorios">RELATÓRIOS</router-link>
          </li>
          <li>
            <router-link to="/cliente/perfil">PERFIL</router-link>
          </li>

        </template>
        <li @click="SET_LOGOUT()">SAIR</li>
      </ul>
    </div>

    <div class="row grid-2-g grid-1-m grid-8-s align-center">
      <img src="../assets/img/logo26.svg" class="logo show-g" alt="Logo NetSupport" />
      <img src="../assets/img/logo26.svg" class="logo-icon hide-g" alt="NetSupport" />
    </div>

    <div class="grid-7 hide-s">
      <ul class="menu row hide-s">
        <template v-if="user.perfil == 'agregado_cliente'">
          <!-- <li :class="menu.remote ? 'active': ''" @click="changeMenu('remote')">
            <router-link to="/cliente/historico">HISTÓRICO</router-link>
          </li> -->
        </template>
        <template v-else>
          <li :class="menu.dashboard ? 'active' : ''" @click="changeMenu('dashboard')">
            <router-link to="/cliente/dashboard">DASHBOARD</router-link>
          </li>
          <li :class="menu.attendance ? 'active' : ''" @click="changeMenu('attendance')">
            <router-link to="/cliente/acompanhamento">ACOMPANHAMENTO</router-link>
          </li>
          <li v-if="user.nova_solicitacao" :class="menu.newJob ? 'active' : ''" @click="changeMenu('newJob')">
            <router-link to="/cliente/job/novo">NOVA SOLICITAÇÃO</router-link>
          </li>
          <li v-if="user.url_relatorio" :class="menu.report ? 'active' : ''" @click="changeMenu('report')">
            <router-link to="/cliente/relatorios">RELATÓRIOS</router-link>
          </li>
        </template>


      </ul>
    </div>

    <div class="grid-2-g grid-3-m grid-2-s row align-center justify-end">
      <RemoteInstructions v-if="user.perfil == 'agregado_cliente'" />
      <Notify />
      <!-- <div class="pendencies hide-s">
        <div class="pendencies-content">
          <i class="fa fa-exclamation-triangle"></i>
          PENDÊNCIAS
        </div>
        <div class="ball">3</div>
      </div>-->
    </div>

    <div class="grid-2-g grid-3-m hide-s">
      <UserTab perfil="/cliente/perfil" account="/cliente/conta" />
    </div>
  </div>
</template>

<script>
import UserTab from "@/components/UserTab.vue";
import Notify from "@/components/Notify.vue";
import RemoteInstructions from "@/components/RemoteInstructions.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "HeaderClient",
  components: {
    UserTab,
    Notify,
    RemoteInstructions,
  },
  data() {
    return {
      showMenu: false,
      menu: {
        dashboard: true,
        newJob: false,
        attendance: false,
        remote: false,
        report: false,
      },
    };
  },
  methods: {
    ...mapActions("user", ["SET_LOGOUT"]),
    ...mapMutations("jobs", ["SET_JOBS"]),
    changeMenu(active) {
      this.SET_JOBS([]);
      this.menu = {
        dashboard: false,
        newJob: false,
        attendance: false,
        remote: false,
        report: false,
      };
      this.menu[active] = true;
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.header {
  height: 70px;
  background: white;
  box-shadow: 0px 0px 4px rgba($purple, 0.1);
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  @media (max-width: $small) {
    height: 82px;
  }

  .logo {
    width: 233px;
    height: 53px;
    display: none;

    &-icon {
      width: 90px;
      margin: auto;
    }
  }

  .menu {
    list-style: none;
    color: $font-color;
    font-size: 14px;
    font-weight: bold;

    &>li {
      a {
        padding: 30px 0px;
        color: $font-color;

        &:hover {
          color: $supporter-1 !important;
        }
      }

      margin-right: 25px;

      @media (min-width: $large) {
        margin-right: 50px;
      }

      padding: 25px 0px;

      &:hover {
        color: $supporter-1 !important;
        cursor: pointer;

        & ul {
          display: block;

          li {
            padding: 15px 25px;
            text-transform: uppercase;

            &:hover {
              color: $supporter-1;
            }
          }
        }
      }

      ul {
        display: none;
        list-style: none;
        position: absolute;
        background: $gray-3;
        margin-top: 45px;
        margin-left: -25px;
        padding: 10px 0px;
      }
    }

    .arrow-down {
      margin-left: 10px;
      font-size: 12px;
      color: $font-color;
    }

    .active {
      color: $supporter-1;
    }

    .pendencies {
      & i {
        margin-right: 7px;
        font-size: 14px;
      }

      .ball {
        float: right;
        border-radius: 50%;
        font-size: 12px;
        min-width: 17px;
        height: 17px;
        line-height: 14px;
        font-weight: bold;
        text-align: center;
        margin-top: -30px;
        margin-right: -15px;
        color: $white;
        background: $red-1;
      }
    }

    &-mobile {
      color: $font-color;
      font-size: 30px;
      display: none;
      cursor: pointer;

      .menu {
        width: 0%;
        width: 100%;
        background: black;
        position: absolute;
        top: -160%;
        z-index: 990;
        font-size: 20px;
        border-radius: 0 0 21px 21px;

        &.opened {
          top: 80px;
        }

        li {
          padding: 1rem 20px;

          a {
            padding: 25px 0px;
          }
        }

        ul {
          padding: 0px;
          width: 100%;

          li {
            padding: 25px 5%;
          }
        }
      }

      button {
        margin: 15% auto;
        display: block;
        width: 45px;
        height: 45px;
        position: relative;
        display: block;
        width: 18px;
        height: 2px;
        background: #fff;
        border-radius: 3px;
        cursor: pointer;
        transition: transform 0.2s ease;

        &::before {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          top: -12px;
          left: 0px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }

        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          left: 0px;
          top: 12px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }

        &.close {
          left: 5px;
          position: relative;
          display: block;
          width: 0;
          height: 0;
          background: transparent;
          transform: rotate(-180deg);

          &::before {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(-45deg);
            transition: transform 0.3s ease;
          }

          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(45deg);
            transition: transform 0.3s ease;
          }
        }
      }

      i {
        margin-left: 20px;
      }

      & ul {
        .active {
          border-bottom: none;
        }
      }

      & ul li ul {
        display: block;
        position: inherit;
        margin-left: -100px;
        /* width: 100% */
      }

      .pendencies {
        & i {
          margin-right: 7px;
          font-size: 14px;
        }

        .ball {
          float: right;
          border-radius: 50%;
          font-size: 12px;
          min-width: 17px;
          height: 17px;
          line-height: 14px;
          font-weight: bold;
          text-align: center;
          margin-top: -30px;
          margin-right: -15px;
          color: $white;
          background: $red-1;
        }
      }
    }
  }
}
</style>
